import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
class SearchBox extends Component {
    constructor() {
        super(...arguments);
        this.handleChange = (e) => this.props.onChange(e.target.value);
        this.handleSearch = (e) => {
            e.preventDefault();
            this.props.onSearch();
        };
    }
    render() {
        const { t } = this.props;
        return (React.createElement("form", { onSubmit: this.handleSearch },
            React.createElement("div", { className: "flex search-wrapper" },
                React.createElement("input", { type: "search", className: "w-full form-field", value: this.props.searchTerm, placeholder: titleize(t('SEARCH')), onChange: this.handleChange }),
                React.createElement("button", { type: "submit", title: t('SEARCH_ORDERS'), className: "flex items-center search-icon button button-green", onClick: this.handleSearch },
                    React.createElement("i", { className: "fa fa-search" })))));
    }
}
SearchBox.propTypes = {
    onChange: PropTypes.func.isRequired,
    onSearch: PropTypes.func.isRequired,
    searchTerm: PropTypes.string,
};
export default withTranslation()(SearchBox);
